import { useSelector } from 'react-redux';

import { RootState } from '../../rootReducer';

export const useListQuotesAllLoaded = (list?: string): boolean => {
  return useSelector<RootState, boolean>(state =>
    list ? !!state.quotesToLists.allLoaded[list] : false
  );
};
